module.exports = __webpack_public_path__ + "static/images/components/UpgradeIcon/images/arrow-4.9ae8de99.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeIcon/images/arrow-4.png
// module id = 2699
// module chunks = 11